import lrCheckbox from './_src/lrCheckbox.vue'

lrCheckbox.install = function(Vue) {
  Vue.component(lrCheckbox.name, lrCheckbox)
}

export default lrCheckbox